module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top-icon-wrapper text-center pb-4"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/mail.svg'),
      "width": "49",
      "height": "44",
      "alt": "send airplane icon"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "text-sf-pro text-20"
  }, [_vm._v("Sent another confirmation email to")]), _vm._v(" "), _c('div', {
    staticClass: "text-sf-pro email"
  }, [_vm._v(_vm._s(_vm.userEmail))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a80f13b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/auth/onboarding/confirmEmail.vue
// module id = 1631
// module chunks = 180